
import { defineComponent, ref, computed, reactive } from 'vue';
import QuestionForm from '@/components/askus/QuestionForm.vue';
import Login from '@/components/user/Login.vue';
import OverlayPanel from 'primevue/overlaypanel';
import Message from 'primevue/message';
import { askusStore } from '@/store/askus-store';
import { domainStore } from '@/store/domain-store';
import { userStore } from '@/store/user-store';
import { IAskusQuestion } from '@/models/askus.model';

export default defineComponent({
  name: 'Askus',
  props: {},
  components: {
    QuestionForm,
    OverlayPanel,
    Login,
    Message,
  },
  emits: ['openQuestion'],

  setup(props, context) {
    const loginOP = ref();
    const showQuestionForm = ref(false);
    const feedbackMessage = reactive({
      message: '',
      type: '',
    });

    const askus = computed(() => {
      return askusStore.getState().askus;
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const newQuestionsEnabled = computed(() => {
      return askus.value.new_questions;
    });
    const canAskQuestion = computed(() => {
      if (!newQuestionsEnabled.value) {
        return false;
      }
      if (askus.value.anon_questions) {
        return true;
      } else {
        return isLoggedIn.value;
      }
    });

    function toggleLogin(event: any) {
      loginOP.value.show(event);
    }
    function openQuestion(question: IAskusQuestion, questionid: number) {
      context.emit('openQuestion', question, questionid);
    }
    function closeQuestionForm(data: any) {
      showQuestionForm.value = false;
      if (data && data.showSuccess) {
        feedbackMessage.message =
          'Ihre Frage wurde erfolgreich eingereicht. Sie wird nun geprüft und ist anschließend öffentlich sichtbar.';
        feedbackMessage.type = 'success';
        askusStore.fetchQuestions();
      } else {
        feedbackMessage.message = '';
        feedbackMessage.type = '';
      }
    }
    function openQuestionForm(event: any) {
      if (canAskQuestion.value) {
        showQuestionForm.value = true;
      } else if (newQuestionsEnabled.value) {
        toggleLogin(event);
      }
    }

    return {
      askus,
      domainid,
      isLoggedIn,
      loginOP,
      newQuestionsEnabled,
      showQuestionForm,
      feedbackMessage,
      openQuestion,
      closeQuestionForm,
      openQuestionForm,
    };
  },
});
